import { Button } from '@/components/ui/Button/Button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/Popover/Popover';
import { cn } from '@/utils';

import notificationsFilledIcon from '@/assets/custom-icons/notifications-filled-white.svg';
import notificationsIcon from '@/assets/custom-icons/notifications.svg';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetNotificationsInfinite } from '../../api/getNotifications';
import { NotificationsList } from '../NotificationsList/NotificationsList';

export const NotificationsPopover = () => {
  const { t } = useTranslation('components', { keyPrefix: 'notificationsPopover' });

  const [isOpen, setIsOpen] = useState(false);

  const { data } = useGetNotificationsInfinite({ limit: 20 });
  const hasUnreadNotifications = (data?.pages[0]?.unreadCount ?? 0) > 0;

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger asChild data-testid='notifications-popover'>
        <Button
          className={cn(
            'text-text-default-primary bg-fill-background-neutral hover:bg-fill-background-neutral active:bg-fill-background-neutral w-full justify-start rounded-lg px-2.5 py-3',
            isOpen && 'bg-text-brand-primary hover:bg-text-brand-primary active:bg-text-brand-primary',
          )}
        >
          <div className='flex items-center gap-3'>
            <div className='relative'>
              {hasUnreadNotifications && !isOpen && (
                <>
                  <div
                    className={'bg-text-brand-primary outline-fill-background-neutral absolute -top-0.5 right-0 size-2 rounded-full outline-2'}
                    data-testid='unread-indicator'
                  />
                  <span className='sr-only'>{t('unreadAriaLabel')}</span>
                </>
              )}
              <img src={isOpen ? notificationsFilledIcon : notificationsIcon} alt='' className='size-5' aria-hidden />
            </div>
            <span className={cn(isOpen && 'text-fill-background-neutral text-body-m-semibold')}>{t('button.label')}</span>
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className='bg-fill-background-neutral z-10 h-screen max-h-[680px] w-[420px] overflow-y-auto p-0'
        side='right'
        align='start'
        sideOffset={16}
        aria-labelledby='notifications-title'
      >
        <NotificationsList closePopover={() => setIsOpen(false)} />
      </PopoverContent>
    </Popover>
  );
};
